import { axiosInstance } from '../Config/axios';

const API_URL = 'v1/dependencies/';
const API_DELETED_URL = `v1/dependencies-deleted/`;
const CONFIG_URL = 'v1/dependencies/config/';

// Obtener todas las dependencias
export const getDependencies = async (params) => {
  try {
    const response = await axiosInstance.get(API_URL, { params });
    return response.data;
  } catch (error) {
    console.error("Error al obtener las dependencias:", error);
    throw error;
  }
};

// Obtener únicamente los subprocesos pertenecientes a procesos diagramables
export const getProcessDependencies = async (params = {}) => {
  try {
    const response = await axiosInstance.get(API_URL, {
      params: { allows_workflow: true, ...params },
    });
    return response.data;
  } catch (error) {
    console.error("Error al obtener los subprocesos diagramables:", error);
    throw error;
  }
};

// Obtener una dependencia específica por código
export const getDependencyByCode = async (code) => {
  try {
    const response = await axiosInstance.get(`${API_URL}${code}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener la dependencia con código ${code}:`, error);
    throw error;
  }
};

// Crear una nueva dependencia
export const createDependency = async (data) => {
  try {
    const response = await axiosInstance.post(API_URL, data);
    return response.data;
  } catch (error) {
    console.error("Error al crear la dependencia:", error);
    throw error;
  }
};

// Actualizar una dependencia por código
export const updateDependency = async (code, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}${code}/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error al actualizar la dependencia con código ${code}:`, error);
    throw error;
  }
};

// Actualizar parcialmente una dependencia sin sobrescribir atributos no editados
export const patchDependency = async (code, data) => {
  try {
    const response = await axiosInstance.patch(`${API_URL}${code}/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error al actualizar la dependencia con código ${code}:`, error);
    throw error;
  }
};

// Eliminar una dependencia por código
export const deleteDependency = async (code) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}${code}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al eliminar la dependencia con código ${code}:`, error);
    throw error;
  }
};

///////

// TIPOS DE DEPENDENCIA

// Obtener los tipos de dependencia
export const getDependencyTypes = async () => {
  try {
    const response = await axiosInstance.get(`${CONFIG_URL}types/`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener los tipos de dependencia:", error);
    throw error;
  }
};

// Obtener un tipo de dependencia en particular
export const getDependencyTypeById = async (id) => {
  try {
    const response = await axiosInstance.get(`${CONFIG_URL}types/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener el tipo de dependencia con ID ${id}:`, error);
    throw error;
  }
};

// Crear un nuevo tipo de dependencia
export const createDependencyType = async (data) => {
  try {
    const response = await axiosInstance.post(`${CONFIG_URL}types/`, data);
    return response.data;
  } catch (error) {
    console.error("Error al crear un nuevo tipo de dependencia:", error);
    throw error;
  }
};

// Actualizar un tipo de dependencia
export const updateDependencyType = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${CONFIG_URL}types/${id}/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error al actualizar el tipo de dependencia con ID ${id}:`, error);
    throw error;
  }
};

// Eliminar un tipo de dependencia
export const deleteDependencyType = async (id) => {
  try {
    await axiosInstance.delete(`${CONFIG_URL}types/${id}/`);
    return { success: true };
  } catch (error) {
    console.error(`Error al eliminar el tipo de dependencia con ID ${id}:`, error);
    throw error;
  }
};

// ATRIBUTOS DE DEPENDENCIA

// Obtener los atributos de dependencia
export const getDependencyAttributes = async () => {
  try {
    const response = await axiosInstance.get(`${CONFIG_URL}atributes/`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener los atributos de dependencia:", error);
    throw error;
  }
};

// Obtener el atributo de dependencia en particular
export const getDependencyAttributesById = async (id) => {
  try {
    const response = await axiosInstance.get(`${CONFIG_URL}atributes/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener el atributo de dependencia con ID ${id}:`, error);
    throw error;
  }
};

// Crear un nuevo atributo de dependencia
export const createDependencyAttribute = async (data) => {
  try {
    const response = await axiosInstance.post(`${CONFIG_URL}atributes/`, data);
    return response.data;
  } catch (error) {
    console.error("Error al crear un nuevo atributo de dependencia:", error);
    throw error;
  }
};

// Actualizar un atributo de dependencia
export const updateDependencyAttribute = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${CONFIG_URL}atributes/${id}/`, data);
    return response.data;
  } catch (error) {
    console.error("Error al actualizar el atributo de dependencia:", error);
    throw error;
  }
};

// Eliminar un atributo de dependencia
export const deleteDependencyAttribute = async (id) => {
  try {
    const response = await axiosInstance.delete(`${CONFIG_URL}atributes/${id}/`);
    return response.data;
  } catch (error) {
    console.error("Error al eliminar el atributo de dependencia:", error);
    throw error;
  }
};

// Función para listar las dependencias eliminadas (GET)
export const getDependencyDeleted = async () => {
  try {
    const response = await axiosInstance.get(API_DELETED_URL);
    return response.data;
  } catch (error) {
    console.error('Error al obtener las dependencias eliminados:', error);
    throw error;
  }
};

// Obtener una dependencia eliminada por código (GET)
export const getDependenciesDeletedByCode = async (code) => {
  try {
    const response = await axiosInstance.get(`${API_DELETED_URL}${code}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener el dependencia eliminada con código ${code}:`, error);
    throw error;
  }
};
